<template>
  <h-dialog
    v-model="formVisible"
    title="上传图片"
    width="860px"
    height="700px"
    class="uploadDialog"
    zIndex="1000"
    @close="close"
  >
    <div class="header">
      <div class="header-left">
        <span class="header-title">搜索结果</span>
        <div class="header-left-switch">
          <span class="header-title">目标框</span
          ><el-switch
            v-model="targerVal"
            inline-prompt
            active-text="是"
            inactive-text="否"
          />
        </div>
      </div>
      <div class="header-right">
        <span class="header-title">自由截取</span>
      </div>
    </div>
    <div class="content">
      <div class="content-common left">
        <h-cropper
          id="cropperDom"
          ref="cropperRef"
          :imgUrl="cropperImg"
          :overBool="true"
          :autoBack="true"
          @getImgAxiss="getImgAxiss"
          @imgFinish="imgFinish"
        ></h-cropper>
      </div>
      <div class="content-common right">
        <div
          class="content-right-top"
          @click="screenShot"
          :class="{ clickShowScreenShot: showScreenShot }"
        >
          <div class="showDescribe" v-if="showScreenShot">
            <i class="iconfont icon-jianqie"></i>
            <span>指定截图目标类型</span>
          </div>
          <div class="showScreenShot" v-else>
            <div class="showScreenShotImg">
              <img :src="getImgFinish" alt="" v-if="getImgFinish" />
            </div>
            <div class="showScreenShotSelect">
              <el-button
                v-for="item in screenShotSelect"
                :key="item.value"
                @click.stop="clickScreenShotBtn(item.value, item.name)"
                >{{ item.name }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="content-title">待选图片(最多不超过6张)</div>
        <div class="content-right-bottom">
          <h-picture
            :data="selectPicture"
            @handle-delete="handleDelete"
            @handle-checked="handleChecked"
          ></h-picture>
        </div>
      </div>
    </div>
    <template #button>
      <div class="footer">
        <h-button type="primary" @click="sure()">确定</h-button>
        <h-button @click="close">取消</h-button>
      </div>
    </template>
  </h-dialog>
</template>
<script>
import { ElMessage } from "element-plus";
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watchEffect,
  ref,
  nextTick,
} from "vue";
import { getImageSize } from "@/utils/library/js/util.js";
// import HPicture from "@src/components/global/HPicture.vue";
// import HPicture from "../../../../components/global/HPicture.vue";
export default defineComponent({
  name: "uploadDialog",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    uploadImg: {
      type: String,
      default: "",
    },
    fileObj: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const state = reactive({
      formVisible: false,
      moveVisible: false,
      transferKeys: [9],
      targerVal: "是",
      showScreenShot: true,
      screenShotSelect: [
        { name: "人脸", value: "1" },
        { name: "人体", value: "2" },
        { name: "机动车", value: "3" },
        { name: "非机动车", value: "4" },
        // { name: "特征", value: "5" },
        { name: "放弃截图", value: "6" },
      ],
      cropperImg: "",

      selectPicture: [],
      getImgFinish: "", //截图对应的base64文件
      getImgValue: "", //截图对应的特征
      getImgAxiss: {}, //截图对应的相对坐标
      getImgFinishList: [], //所有截图照片信息
      checkedImgFinishList: [], //选中的截图照片信息
      analyseImg: [], //上传图片后解析结果
    });
    const refData = toRefs(state);
    const cropperRef = ref(null);

    watchEffect(() => {
      state.formVisible = props.modelValue;
      state.analyseImg = props.fileObj;
      nextTick(() => {
        changeFileObj(state.analyseImg[0]);
      });
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
      if (props.uploadImg) {
        state.cropperImg = props.uploadImg;
        getImageSize(state.cropperImg, (data) => {
          const cropper = document.getElementById("cropperDom");
          if (cropper && parseFloat(data.width) > parseFloat(data.height)) {
            cropper.style.width = "474px";
            cropper.style.height =
              (474 / parseFloat(data.width)) * parseFloat(data.height) + "px";
          } else if (
            cropper &&
            parseFloat(data.width) < parseFloat(data.height)
          ) {
            cropper.style.height = "498px";
            (498 / parseFloat(data.height)) * parseFloat(data.width);
            cropper.style.width =
              (498 / parseFloat(data.height)) * parseFloat(data.width) + "px";
          }
        });
      }
    });
    const sure = () => {
      if (state.checkedImgFinishList.length == 0) {
        ElMessage.warning("请选择图片");
        return;
      }
      state.formVisible = false;
      context.emit("emitCheckedImg", state.checkedImgFinishList);
    };
    const changeFileObj = (val) => {
      for (let obj in val) {
        if (obj !== "fileName" && val[obj]) {
          console.log(val[obj]);
          val[obj].forEach((element) => {
            element.name = obj;
            state.selectPicture.push(element);
          });
        }
      }
    };
    //开始截图
    const screenShot = () => {
      state.showScreenShot = false;
      state.getImgAxiss = {};
      cropperRef.value && cropperRef.value.startCrop();
    };
    // 确认or放弃截图
    const clickScreenShotBtn = (value, name) => {
      console.log(state.getImgAxiss);
      if (value === "6") {
        // state.showScreenShot = true;
        cropperRef.value && cropperRef.value.stopCrop();
      } else {
        state.getImgValue = value;
        cropperRef.value && cropperRef.value.finish();
        cropperRef.value && cropperRef.value.stopCrop();
        if (state.selectPicture.length > 5) {
          ElMessage.warning("最多添加六张照片");
        } else {
          const obj = {
            url: state.getImgFinish,
            value: state.getImgValue,
            roi: state.getImgAxiss,
            type: name
          };
          state.selectPicture.push(obj);
        }
      }
      console.log(state.selectPicture);
      state.showScreenShot = true;
    };
    const handleDelete = (file) => {
      console.log(file);
    };
    //选中图片信息
    const handleChecked = (checked) => {
      state.checkedImgFinishList = checked;
    };
    //获取截图坐标
    const getImgAxiss = (axiss) => {
      const cropper = document.getElementById("cropperDom");
      getImageSize(state.cropperImg, (data) => {
        const { x1, x2, y1, y2 } = axiss;
        console.log(axiss, x2 == y2);
        if (x2 == "0" && y2 == "0") {
          state.getImgAxiss.x1 = 0;
          state.getImgAxiss.x2 = data.width;
          state.getImgAxiss.y1 = 0;
          state.getImgAxiss.y2 = data.height;
          return;
        }
        state.getImgAxiss.x1 =
          (data.width / parseFloat(cropper.style.width)) * x1;
        state.getImgAxiss.x2 =
          (data.width / parseFloat(cropper.style.width)) * x2;
        state.getImgAxiss.y1 =
          (data.height / parseFloat(cropper.style.height)) * y1;
        state.getImgAxiss.y2 =
          (data.height / parseFloat(cropper.style.height)) * y2;
      });
    };
    //base64图片
    const imgFinish = (base64) => {
      state.getImgFinish = base64;
    };
    //关闭
    const close = () => {
      state.formVisible = false;
      context.emit("emitCheckedImg", []);
    };

    return {
      ...refData,
      cropperRef,
      sure,
      screenShot,
      clickScreenShotBtn,
      handleDelete,
      handleChecked,
      getImgAxiss,
      imgFinish,
      close,
    };
  },
});
</script>
<style lang="scss" scoped>
.header {
  @include flex-row-s-c;
  .header-left {
    @include flex-row-sb-c;
    border-left: 4px solid #333;
    margin-right: 8px;
    width: 60%;
  }

  .header-right {
    border-left: 3px solid #333;
  }
  .header-title {
    padding: 0 11.5px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
  }
}
.content {
  width: 100%;
  height: 50vh;
  margin: 30px 0 0 0;
  @include flex-row-c-c;
  .content-common {
    height: 100%;
    &.left {
      @include flex-row-c-c;
      width: 60%;
      // padding: 0 5%;
      margin: 0 8px;
      height: 498px;
      border: 1px dashed #692828;
    }
    &.right {
      width: 40%;
      .content-right-top {
        width: 100%;
        height: 45%;
        text-align: center;
        border: 1px dashed #692828;
        &.clickShowScreenShot {
          height: 25%;
        }
        .showDescribe {
          padding: 10%;
          cursor: pointer;
          span {
            margin-left: 8px;
          }
        }
        .showScreenShot {
          height: 100%;
          @include flex-row-sb-c;
          padding: 0 15px;
          .showScreenShotImg {
            width: 45%;
            height: 80%;
            border: 1px solid;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .showScreenShotSelect {
            width: 30%;
            height: 100%;
            overflow: auto;
            .el-button {
              width: 70px;
            }
            /deep/.el-button + .el-button {
              margin-left: 0px;
            }
          }
        }
      }
      .content-title {
        border-left: 4px solid #333;
        height: 5%;
        margin-top: 10px;
      }
      .content-right-bottom {
        width: 100%;
        height: 50%;
        margin-top: 15px;
        display: flex;
        flex-wrap: wrap;
        padding: 10px;
        border: 1px dashed #692828;
        overflow: auto;
      }
    }
  }
}
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
